import React from "react";
import SchoolFooter from "./footer/SchoolFooter";
import "./SchoolMain.css";

const SchoolMain = ({ children }) => {

    return (
        <>
        <main className="school-main">
            <div className="school-container">
                {children}
                <SchoolFooter />
            </div>
        </main>
        </>
    );
};


export default SchoolMain;